import { BookOpen, Award, Microscope, Users, GraduationCap, Target } from 'lucide-react';

export const mockData = {
  stats: [
    { value: '22+', label: 'Years of Experience' },
    { value: '15+', label: 'World Toppers' },
    { value: '500+', label: 'Students Mentored' },
    { value: '2', label: 'Curricula Expertise' }
  ],

  expertise: [
    {
      icon: GraduationCap,
      title: 'IGCSE / Cambridge Chemistry',
      description: 'Comprehensive coverage of Cambridge curriculum',
      points: [
        'Complete syllabus mastery',
        'Past paper practice',
        'Exam strategy & technique',
        'International board preparation'
      ]
    },
    {
      icon: BookOpen,
      title: 'CBSE Chemistry',
      description: 'In-depth CBSE board preparation',
      points: [
        'NCERT-aligned teaching',
        'Board exam focus',
        'Concept clarity',
        'Competitive exam readiness'
      ]
    },
    {
      icon: Microscope,
      title: 'Practical Chemistry',
      description: 'Hands-on laboratory training',
      points: [
        'Lab skills development',
        'Experimental techniques',
        'Safety protocols',
        'Report writing mastery'
      ]
    }
  ],

  achievements: [
    {
      title: 'Concept-Driven',
      description: 'Deep understanding over memorization'
    },
    {
      title: 'Performance Tracking',
      description: 'Individual progress monitoring'
    },
    {
      title: 'Problem-Solving',
      description: 'Advanced analytical methods'
    },
    {
      title: 'Exam Temperament',
      description: 'Confidence building strategies'
    }
  ],

  testimonials: [
    {
      name: 'Ananya Sharma',
      achievement: 'World Topper - IGCSE Chemistry 2023',
      text: 'Tejeswi ma\'am\'s teaching transformed my understanding of Chemistry. The practical approach made complex concepts crystal clear.'
    },
    {
      name: 'Rohan Patel',
      achievement: '99% in CBSE Chemistry - Class 12',
      text: 'The personalized attention and exam strategies helped me achieve my dream score. Best Chemistry teacher I\'ve ever had!'
    },
    {
      name: 'Priya Krishnan',
      achievement: 'Cambridge Distinction - A* Grade',
      text: 'Ma\'am\'s focus on fundamentals and practical work gave me the confidence to excel in both theory and practicals.'
    }
  ],

  methodology: [
    {
      title: 'Clear Fundamentals Before Memorization',
      description: 'Building strong conceptual foundations before moving to complex topics. Every principle is explained from first principles with real-world applications.'
    },
    {
      title: 'Step-by-Step Complexity Building',
      description: 'Gradual progression from basic to advanced concepts ensuring no knowledge gaps. Each topic builds logically on previous learning.'
    },
    {
      title: 'Personalized Mentoring',
      description: 'Individual attention to each student\'s learning pace, strengths, and areas needing improvement. Customized study plans for optimal results.'
    },
    {
      title: 'Continuous Assessment & Feedback',
      description: 'Regular testing, performance analysis, and constructive feedback to track progress and address weaknesses promptly.'
    }
  ],

  practicalFocus: [
    {
      title: 'Practical Chemistry & Laboratory Skills',
      description: 'Hands-on training in conducting experiments, using equipment safely, and understanding chemical reactions through observation.'
    },
    {
      title: 'Experimental Accuracy & Reporting',
      description: 'Developing precision in measurements, data recording, and scientific report writing - essential skills for board practicals.'
    },
    {
      title: 'Theory-Lab Linkage',
      description: 'Connecting theoretical concepts with practical observations to develop deeper understanding and retention.'
    },
    {
      title: 'Curriculum-Aligned Preparation',
      description: 'Practical training specifically designed for IGCSE and CBSE board practical examinations and assessments.'
    }
  ],

  grades: [
    { id: '9', name: 'Grade 9', description: 'Foundation building for Chemistry' },
    { id: '10', name: 'Grade 10', description: 'Board preparation - IGCSE/CBSE' },
    { id: '11', name: 'Grade 11', description: 'Advanced concepts introduction' },
    { id: '12', name: 'Grade 12', description: 'Complete board & competitive prep' }
  ]
};
